import { c as _c } from "react/compiler-runtime";
import Img from '@/components/elements/Img';
const EntityImage = t0 => {
    var _a;
    const $ = _c(9);
    const { image, hasLink } = t0;
    const t1 = image === null || image === void 0 ? void 0 : image.url;
    const t2 = (_a = image === null || image === void 0 ? void 0 : image.caption) !== null && _a !== void 0 ? _a : "entity image";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            url: t1,
            caption: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    }
    else {
        t3 = $[2];
    }
    const { url, caption } = t3;
    const imageClassName = `w-full h-full object-cover transform origin-center transition duration-500 ${hasLink ? "group-hover:scale-110 group-focus:scale-110 group-focus-within:scale-110" : ""}`;
    let t4;
    if ($[3] !== caption || $[4] !== imageClassName || $[5] !== url) {
        t4 = url ? <Img src={url} alt={caption} sizes={"(max-width: 519px) 65vw,\n              (max-width: 849px) 39vw,\n              (max-width: 1200px) 33vw,\n              25vw\n              "} className={imageClassName}/> : null;
        $[3] = caption;
        $[4] = imageClassName;
        $[5] = url;
        $[6] = t4;
    }
    else {
        t4 = $[6];
    }
    let t5;
    if ($[7] !== t4) {
        t5 = <><div className="relative w-full h-full"><div className="relative w-full h-full overflow-hidden">{t4}</div></div></>;
        $[7] = t4;
        $[8] = t5;
    }
    else {
        t5 = $[8];
    }
    return t5;
};
export default EntityImage;
